export const heroSlides = [
  {
    id: "hero-1",
    newsId: "news-1",
    category: "TV动画",
    title: "《葬送的芙莉莲》第二季正式定档，2026 年 1 月温暖回归",
    summary: "官方公开第二季首支预告与主视觉，芙莉莲与费伦的旅程将继续向北，动画制作仍由 Madhouse 担任。",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20stylized%20anime%20illustration%20of%20a%20lone%20mage%20girl%20walking%20through%20a%20vast%20snowy%20fantasy%20valley%20under%20a%20golden%20dusk%20sky%2C%20cinematic%20wide%20composition%2C%20deep%20blue%20and%20warm%20amber%20tones%2C%20painterly%20texture%2C%20empty%20space%20on%20the%20left%2C%20no%20text&width=1920&height=900&seq=hero-focus-01&orientation=landscape",
  },
  {
    id: "hero-2",
    newsId: "news-2",
    category: "剧场版",
    title: "剧场版《鬼灭之刃 无限城篇》票房突破 300 亿日元",
    summary: "上映六周后，无限城篇累计票房正式突破 300 亿日元，成为本年度最具话题度的动画电影之一。",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20stylized%20anime%20illustration%20of%20a%20glowing%20traditional%20japanese%20castle%20at%20night%20surrounded%20by%20orange%20energy%20effects%20and%20mist%2C%20cinematic%20wide%20composition%2C%20dark%20left%20side%20with%20empty%20space%2C%20rich%20contrast%2C%20no%20text&width=1920&height=900&seq=hero-focus-02&orientation=landscape",
  },
  {
    id: "hero-3",
    newsId: "news-4",
    category: "TV动画",
    title: "《间谍过家家》第三季公开全新主视觉与角色设定",
    summary: "阿尼亚一家再度集结，第三季主视觉以家庭日常与任务线交错为主题，播出时间同步公布。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cinematic%20stylized%20illustration%20of%20a%20cozy%20vintage%20european%20city%20street%20at%20sunset%20with%20soft%20pink%20and%20mint%20light%2C%20wide%20composition%20with%20open%20space%20on%20the%20left%2C%20painterly%20anime%20style%2C%20no%20text&width=1920&height=900&seq=hero-focus-03&orientation=landscape",
  },
  {
    id: "hero-4",
    newsId: "news-10",
    category: "漫画新闻",
    title: "《进击的巨人》十周年纪念展将于东京举办",
    summary: "纪念展将展出原画、设定资料与巨大场景模型，官方同步公开了以城墙与大海为主题的主视觉。",
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20cinematic%20stylized%20illustration%20of%20a%20massive%20ancient%20stone%20wall%20overlooking%20a%20vast%20sea%20at%20dusk%2C%20dramatic%20amber%20and%20deep%20blue%20sky%2C%20painterly%20anime%20style%2C%20empty%20space%20on%20the%20left%2C%20no%20text&width=1920&height=900&seq=hero-focus-04&orientation=landscape",
  },
];